import React from 'react';
import { Chip } from '@mui/material';

const STATUS_CONFIG = {
  paid: { label: 'Paid', color: '#2e7d32', bg: 'rgba(46, 125, 50, 0.12)' },
  partially_paid: { label: 'Partially Paid', color: '#f9a825', bg: 'rgba(249, 168, 37, 0.12)' },
  due_soon: { label: 'Due Soon', color: '#ef6c00', bg: 'rgba(239, 108, 0, 0.12)' },
  upcoming: { label: 'Upcoming', color: '#1565c0', bg: 'rgba(21, 101, 192, 0.12)' },
  overdue: { label: 'Overdue', color: '#d32f2f', bg: 'rgba(211, 47, 47, 0.12)' },
  pending: { label: 'Pending', color: '#f9a825', bg: 'rgba(249, 168, 37, 0.12)' },
  credit: { label: 'Credit', color: '#7b1fa2', bg: 'rgba(123, 31, 162, 0.12)' },
  active: { label: 'Active', color: '#1976d2', bg: 'rgba(25, 118, 210, 0.12)' },
  expired: { label: 'Expired', color: '#757575', bg: 'rgba(117, 117, 117, 0.12)' },
  cancelled: { label: 'Cancelled', color: '#757575', bg: 'rgba(117, 117, 117, 0.12)' },
  suspended: { label: 'Suspended', color: '#ed6c02', bg: 'rgba(237, 108, 2, 0.12)' },
  failed: { label: 'Failed', color: '#d32f2f', bg: 'rgba(211, 47, 47, 0.12)' },
};

const defaultConfig = { label: '—', color: '#616161', bg: 'rgba(97, 97, 97, 0.12)' };

/**
 * Reusable status badge for finance screens.
 * Maps status string to color: Paid=green, Partially Paid=yellow, Due Soon=amber, Overdue=red, etc.
 */
const StatusBadge = ({ status, label, size = 'small' }) => {
  const key = (status || '').toLowerCase().replace(/\s/g, '_');
  const config = STATUS_CONFIG[key] || (label ? { label, ...defaultConfig } : defaultConfig);
  const displayLabel = label || config.label;

  return (
    <Chip
      label={displayLabel}
      size={size}
      sx={{
        fontWeight: 600,
        backgroundColor: config.bg,
        color: config.color,
        border: `1px solid ${config.color}`,
      }}
    />
  );
};

export default StatusBadge;
export { STATUS_CONFIG };
